import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '../components/Dialog';
import Input from '../components/Input';
import Select from '../components/Select';
import Button from '../components/Button';

export default function UserDialog({ open, form, setForm, options, onClose, onSubmit, editing, width }) {
  return (
    <Dialog open={open} onClose={onClose} width={width}>
      <DialogTitle>{editing ? 'Edycja użytkownika' : 'Nowy użytkownik'}</DialogTitle>
      <DialogContent>
        <div className="space-y-4 mt-2">
            <div className="md:flex gap-4">
          <Input size="small" label="Imię i nazwisko" value={form.us_name || ''} onChange={e => setForm(v => ({ ...v, us_name: e.target.value }))} fullWidth />
          <Input size="small" label="Login" value={form.us_login || ''} onChange={e => setForm(v => ({ ...v, us_login: e.target.value }))} fullWidth />
          </div>
                    <Input size="small" label="Email" value={form.email || ''} onChange={e => setForm(v => ({ ...v, email: e.target.value }))} fullWidth />

            <div className="md:flex gap-4">
          <Select
            label="Rola"
            size="small"
            value={form.RoleId || ''}
            onChange={e => setForm(v => ({ ...v, RoleId: e.target.value }))}
            fullWidth
            options={options.roles.map(r => ({ value: r.id, label: r.role_name }))}
          />

          <Select
            label="Firma"
            size="small"
            value={form.companyId || ''}
            onChange={e => setForm(v => ({ ...v, companyId: e.target.value }))}
            fullWidth
            options={options.companies.map(c => ({ value: c.id, label: c.CompnyName }))}
          />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button type="button" size="small" onClick={onClose} variant="outlined">Anuluj</Button>
        <Button type="button" size="small" onClick={onSubmit} variant="contained" color='success'>Zapisz</Button>
      </DialogActions>
    </Dialog>
  );
}
